import { useChainedCommands, useCommands } from '@remirror/react';
import { useUploadImageHandler } from '../components/Editor/UploadFileHandler';
import { loadImage } from '../components/Editor/utils';
import { AppFileTypes, mimeTypeToAppType } from '../utils/file/MIMETypeUtils';

interface useEditorUploaderProps {
  pageId: string;
  pos?: number;
}

export const useEditorUploader = ({ pageId, pos }: useEditorUploaderProps) => {
  const commands = useCommands();
  const chain = useChainedCommands();

  const imageUploader = useUploadImageHandler({ pageId });

  const images: File[] = [];
  const files: File[] = [];

  const uploadImages = (files: File[]) => {
    chain.focus(pos).run();
    files.map((file) => {
      commands.uploadImage(
        () => {
          return imageUploader(file, () => {}).then((data) => {
            return loadImage(data.src)
              .then(() => data)
              .catch(() => {
                throw new Error('Unable to load the image');
              });
          });
        },
        (el) => {
          el.setAttribute('class', 'hide-visibility');
          const img = document.createElement('img');
          img.setAttribute('src', URL.createObjectURL(file));
          el.appendChild(img);
          setTimeout(() => {
            el.setAttribute('class', 'loading-animation');
          }, 0);
        },
      );
    });
  };

  const uploadFiles = (files: File[]) => {
    chain.focus(pos).run();
    commands.uploadFiles(files);
  };

  const upload = (uploadedFiles: File[]) => {
    uploadedFiles.forEach((uploadedFile) => {
      switch (mimeTypeToAppType(uploadedFile.type)) {
        case AppFileTypes.IMAGE:
          images.push(uploadedFile);
          break;
        default:
          files.push(uploadedFile);
      }
    });

    if (images.length) {
      uploadImages(images);
    }

    if (files.length) {
      uploadFiles(files);
    }
  };

  return {
    upload,
  };
};
